import React from 'react';
import { setCurrentView } from 'core/utils';
import { observer } from 'mobx-react';
import { DressingRuleEditTemplate } from 'themes/application/dressing-rule/pages';
import { DressingRuleEditViewStore } from '../stores';

@setCurrentView((rootStore) => new DressingRuleEditViewStore(rootStore), 'dressingRuleEditViewStore')
@observer
class DressingRuleEdit extends React.Component {
    render(){
        return <DressingRuleEditTemplate {...this.props }/>
    }
}

export default DressingRuleEdit;